var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstVerificationError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 25C49 38.2548 38.2548 49 25 49C11.7452 49 1 38.2548 1 25C1 11.7452 11.7452 1 25 1C38.2548 1 49 11.7452 49 25Z",
    stroke: "#E26982",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.552 17C27.3627 17 28.8373 17.4293 29.976 18.288C31.1147 19.1467 31.684 20.304 31.684 21.76C31.684 23.3093 31.1987 24.5227 30.228 25.4C29.2573 26.2587 27.988 26.772 26.42 26.94V29.936H24.096V25.736C25.9813 25.456 27.3253 25.036 28.128 24.476C28.9307 23.916 29.332 23.104 29.332 22.04C29.332 21.1253 28.996 20.4067 28.324 19.884C27.652 19.3613 26.672 19.1 25.384 19.1C24.152 19.1 23.144 19.4453 22.36 20.136C21.5947 20.808 21.1373 21.732 20.988 22.908L19 21.76C19.3173 20.304 20.0547 19.1467 21.212 18.288C22.3693 17.4293 23.816 17 25.552 17ZM25.216 32.4C25.7573 32.4 26.196 32.568 26.532 32.904C26.868 33.24 27.036 33.6787 27.036 34.22C27.036 34.7613 26.868 35.2 26.532 35.536C26.196 35.872 25.7573 36.04 25.216 36.04C24.6747 36.04 24.236 35.872 23.9 35.536C23.564 35.2 23.396 34.7613 23.396 34.22C23.396 33.6787 23.564 33.24 23.9 32.904C24.236 32.568 24.6747 32.4 25.216 32.4Z",
    fill: "#E26982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstVerificationError);
export default __webpack_public_path__ + "static/media/first-verification-error.a74463e9.svg";
export { ForwardRef as ReactComponent };